import Vue from 'vue';

export interface ValidationData {
  dirty: boolean;
  pristine: boolean;
  valid: boolean;
  invalid: boolean;
  validated: boolean;
  pending: boolean;
  required: boolean;
  touched: boolean;
  untouched: boolean;
  changed: boolean;
  passed: boolean;
  failed: boolean;
  errors: { [x: string]: string[] };
  validate: ({ silent }: { silent: boolean }) => Promise<any>;
  reset: () => void;
}

class Store<S> {
  private readonly instance: Vue;

  constructor() {
    this.instance = new Vue({
      // fix: [Vue warn]: Avoid adding reactive properties to a Vue instance or its root $data at runtime - declare it upfront in the data option.
      data: {
        dummyKey: null,
      },
    });
  }

  get state(): S {
    return this.instance.$data.dummyKey as S;
  }

  set(id: string, validationData: ValidationData) {
    this.instance.$set(this.instance.$data, 'dummyKey', {
      ...this.instance.$data.dummyKey,
      [id]: validationData,
    });
  }

  delete(id: string) {
    delete this.instance.$data.dummyKey[id];
  }
}

export interface State {
  [id: string]: ValidationData;
}

class ValidationStore extends Store<State> {}

export default ValidationStore;
